import { Header, Page } from 'components'
import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { Card, CardContent, CircularProgress, Grid, Typography, Paper, Divider } from '@material-ui/core'
import MaterialTable from 'material-table'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { useVagaService } from 'hooks/useVagaService'
import { Espelho } from 'components/Espelho'
import { MenuAcoes } from './components/MenuAcoes'
import constants from 'utils/constants'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'

import useStyles from './styles'

export const GerenciamentoDeVagas = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const router = useRouter()
  const vagaService = useVagaService()
  const [vagas, setVagas] = useState([])
  const [idVagaSelecionada, setIdVagaSelecionada] = useState(null)
  const [processandoVagas, setProcessandoVagas] = useState(false)
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [processandoDeletarVaga, setProcessandoDeletarVaga] = useState(false)
  const fetchListarVagas = useCallback(async () => {
    const response = await vagaService.listarVagasAsync(setProcessandoVagas)
    setVagas(response)
  }, [])
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    fetchListarVagas()
  }, [fetchListarVagas])

  const handleClickDeletarVaga = (id) => {
    setIdVagaSelecionada(id)
    setAbrirEspelho(true)
  }

  const handleDeletar = async () => {
    await vagaService.excluirVaga(idVagaSelecionada, setProcessandoDeletarVaga)
    await fetchListarVagas()
    setAbrirEspelho(false)
  }

  const getLabelDisponibilidadeVaga = (vaga) => {
    const dataAtual = new Date()
    const dataVaga = new Date(vaga.data)

    if (!vaga.exSol) {
      if (dataVaga < dataAtual) {
        return 'Data expirada'
      }
      return 'Vaga disponível'
    }

    return `${vaga.exSol.exReal?.numeroExame} - ${vaga.exSol.tipoEx.nome}`
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <Grid alignItems="flex-end" container justifyContent="space-between">
            <Grid item>
              <Typography className={classes.pageTitle}>
                <b>VAGAS DISPONÍVEIS</b>
              </Typography>
            </Grid>
            <Grid item>
              <MenuAcoes />
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} md={12}>
            <Grid item xs={12} sm={12} md={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <MaterialTable
                components={{ Container: (props) => <Paper {...props} elevation={0} /> }}
                title=""
                localization={{
                  body: {
                    emptyDataSourceMessage: processandoVagas ? <CircularProgress disableShrink /> : 'Nenhum cadáver encontrado',
                    filterRow: {
                      filterTooltip: 'Filtro',
                    },
                  },
                  header: {
                    actions: '',
                  },
                }}
                data={vagas}
                columns={[
                  {
                    title: 'Tipo de Exame',
                    render: (rowData) => rowData.tipoEx.nome,
                  },
                  {
                    title: 'Data do Vaga',
                    render: (rowData) => moment(rowData.data).format('LLLL'),
                  },
                  {
                    title: 'Exame solicitado associado',
                    render: (rowData) => getLabelDisponibilidadeVaga(rowData),
                  },
                ]}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  pageSize: 20,

                  headerStyle: {
                    backgroundColor: '#f4f6f8',
                  },
                  toolbar: false,
                }}
                actions={[
                  {
                    icon: DeleteForeverIcon,
                    tooltip: 'Deseja excluir essa vaga cadastrada?',
                    onClick: (event, rowData) => handleClickDeletarVaga(rowData.id),
                  },
                ]}
                icons={{
                  SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
                  NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                  PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
                  FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
                  LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
                }}
                style={{
                  padding: '16px',
                  fontSize: '13px',
                  textAlign: 'left',
                  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                  fontWeight: '400',
                  lineHeight: '21px',

                  letterSpacing: '-0.05px',
                  verticalAlign: 'inherit',
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Espelho aberto={abrirEspelho} setAberto={setAbrirEspelho} handleConfirmar={handleDeletar} processando={processandoDeletarVaga} titulo="CONFIRMAÇÃO DA EXCLUSÃO">
        <Grid item md={12} sm={12} xs={12}>
          <Typography>
            <h3>Deseja excluir a vaga selecionada?</h3>
          </Typography>
        </Grid>
      </Espelho>
    </Page>
  )
}
